import { useState } from 'react';

export default function useMyPhrases(
	getMyPhrasesQuery: any,
	customSkip?: number,
) {
	const [page, setPage] = useState(1);
	const getMyPhrases = (filter: any) => {
		const skip = customSkip ?? 20;
		getMyPhrasesQuery({
			where: filter,
			pagination: {
				...filter.pagination,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getMyPhrases, getNextPage, page, setPage };
}
